import dayjs from 'dayjs';
import React from 'react';
import { CustomFieldDataType } from '../../../enums/CustomFieldDataType';
import { TransactionColKey } from '../../../enums/TransactionColKey';
import BukkuTooltip from '../../Tooltip';

/**
 *
 * @param {{transaction: object[], contact: object[]}} fields - from listApi {transaction: object[], contact: object[]}
 * @returns {{colKeyGroup, key,title,width,render}[]} - multi-columns [ {key,title,width,render}, ...]
 */
export function getTransactionCustomFieldColumns(fields = {}) {
    const transactionCustomFields = fields.transaction || [];
    return transactionCustomFields.map(field => {
        const {
            data_type,
        } = field;

        const renderFn = text => {
            let label = '-';
            if (text)
                label = data_type === CustomFieldDataType.DATE ? dayjs(text).format('DD/MM/YYYY') : text;

            return (
                <span>
                    <BukkuTooltip title={text} placement="topLeft">
                        {label}
                    </BukkuTooltip>
                </span>
            );
        };

        return (
            {
                key: `field_${field.id}`,
                dataIndex: `field_${field.id}`,
                colKeyGroup: TransactionColKey.custom_fields,
                title: (
                    <span className="align-center ">
                        <span className="ellipsis-div">{field.name}</span>
                    </span>

                // <span className="align-center ">
                //     <BukkuTooltip title={t`Custom Field`} placement="topLeft">
                //         <StyledTag color="blue">
                //             <AppstoreAddOutlined />
                //         </StyledTag>
                //     </BukkuTooltip>
                //     <span className="ellipsis-div">{field.name}</span>
                // </span>
                ),
                width: 150,
                ellipsis: true,
                required: false,
                defaulto: false,
                render: renderFn,
            }
        );
    });
}
